// Single source of truth for the iframe/API market codes the widget supports.
// Kept intentionally narrow: no display labels, locale behavior, or exchange
// metadata. Parsed `mkt` values are normalized to upper case before comparison.

export const SUPPORTED_MARKET_CODES = ['JP', 'US'] as const;

export type SupportedMarketCode = (typeof SUPPORTED_MARKET_CODES)[number];

/**
 * True when `value` is already a canonical supported market code (`JP`/`US`).
 * The parsed `mkt` value is normalized (trimmed/uppercased) upstream, so this
 * check compares against the canonical codes without re-normalizing.
 */
export const isSupportedMarketCode = (
  value: string | undefined,
): value is SupportedMarketCode =>
  value !== undefined &&
  SUPPORTED_MARKET_CODES.includes(value as SupportedMarketCode);
